import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions } from 'src/auth';
import Button from 'src/views/components/button';

export class Homepage extends Component {
  
    componentWillMount() {

    }
  
    render() {
      return (
        <div className="g-row">
        Hola
        </div>
      );
    }
  }
  
  export default Homepage;
  


// WEBPACK FOOTER //
// ./src/views/pages/homepage/homepage.js